import React, { useState } from "react";
import AlertIcon from "../../../assets/img/alert_icon.svg";
import AlertIconError from "../../../assets/img/alert_icon_error.svg";
import styles from "./input.module.scss";

export interface InputProps {
  type?: "text" | "number";
  text?: string;
  name?: string;
  value: any;
  readOnly?: boolean;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  onChange?: (valor: any) => void;
  onFocus?: (e: any) => void;
  onBlur?: (e: any) => void;
  onKeyUp?: (e: any) => void;
  id?: string;
  isErrored?: boolean
}

export const TEST_ID = 'input-testid';

export const Input: React.FC<InputProps> = ({
  className,
  text,
  name,
  type,
  value,
  readOnly,
  placeholder,
  onChange,
  onBlur,
  onFocus,
  onKeyUp,
  id,
  isErrored
}) => {

  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true)
  }

  const handleBlur = () => {
    setIsFocused(false)
  }

  return (
    <div data-testid={TEST_ID} className={styles.box}>
      {text ? <label className={styles.textLabel}>{text}</label> : false}

      <div className={`
          ${styles.inputGroup} 
          ${className} 
          ${isFocused && styles.inputGroup__focused}
          ${isErrored && styles.inputGroup__errored}
          `}>
        <div className={styles.inputGroup__ico}>
          <img src={isErrored ? AlertIconError : AlertIcon } alt="alert-icon" />
        </div>

        <div className={`
          ${styles.inputGroup__inputBox}
        `}>
          <input
            autoComplete="off"
            type={type ?? "text"}
            value={value}
            id={id}
            name={name}
            readOnly={readOnly}
            placeholder={placeholder}
            onChange={(e) => onChange?.(e.target.value)}
            onBlur={(e) => {
              onBlur?.(e.target.value)
              handleBlur()
            }}
            onFocus={(e) => {
                onFocus?.(e.target.value)
                handleFocus();
              }
            }
            
            onKeyUp={(e) => onKeyUp?.(e)}
            className={`${styles.input} ${onFocus ? "" : ".input:focus"}`}
          />
        </div>
      </div>
    </div>
  );
};
